import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./Campaigns.scss";

const Campaigns = () => {
  // Définition du titre de la page
  UseTitle("Liste des campagnes");

  const { isAdmin } = useAuth();

  const [listCampaigns, setListCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/campaign/")
      .then((response) => {
        setListCampaigns(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="campaigns">
      {isLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}
      {!isLoading && (
        <>
          {listCampaigns.length === 0 && <p>Pas de campagnes</p>}
          {listCampaigns.length > 0 && (
            <>
              <h1>Campagnes</h1>
              {listCampaigns.map((campaign) => (
                <div key={campaign.id}>
                  <h2>
                    <NavLink to={`/campaign/${campaign.id}`}>
                      {campaign.name}{" "}
                      {isAdmin && <small>({campaign.owner})</small>}
                    </NavLink>
                  </h2>
                </div>
              ))}
            </>
          )}
          <button className="bt" onClick={() => navigate(`/campaign/new`)}>
            Créer une campagne
          </button>
        </>
      )}
    </div>
  );
};

export default Campaigns;
